<template>
  <div class="" v-if="availableN3">
    <div class="dashboard-panels">
      <div class="dashboard-panels--tabs">
        <div>
          <!-- sectionHeader-->
          <div class="d-flex justify-space-between align-center">
            <SectionHeader class="pb-0" first="Gestión" second="N3/Anticipos" />
            <v-btn large class="white--text mr-5" :rounded="$getPrimaryButton('rounded')"
              :outlined="$getPrimaryButton('outlined')" :color="$getPrimaryButton('color')"
              @click="exportN3excel" :disabled="!n3Entries || n3Entries.length === 0"
              :loading="loading" v-if="isSuperAdmin">
              <v-icon left>mdi-file-excel</v-icon>
              Exportar N3
            </v-btn>
            <div class="dashboard-toolbar--insights ml-5 mb-4" style="flex-wrap: inherit;" v-if="stats">
              <div class="dashboard-toolbar--field-group insight-item dashboard_box">
                <div class="dashboard-toolbar--field-group__label">
                  <v-icon small>mdi-cash-multiple</v-icon>
                  Total Importe:
                </div>
                <div class="dashboard-toolbar--field-group__value">
                  <div class="dashboard-toolbar--field-group__value__text">
                    <span class="number">{{ stats.totalAmount }}</span>
                    <span class="unit">€</span>
                  </div>
                </div>
              </div>
              <div class="dashboard-toolbar--field-group insight-item dashboard_box">
                <div class="dashboard-toolbar--field-group__label">
                  <v-icon small color="warning">mdi-clock-outline</v-icon>
                  Pendientes:
                </div>
                <div class="dashboard-toolbar--field-group__value text-orange">
                  <div class="dashboard-toolbar--field-group__value__text">
                    <span class="number">{{ stats.pendingCount }}</span>
                    <span class="unit"> solicitudes</span>
                  </div>
                </div>
              </div>
              <div class="dashboard-toolbar--field-group insight-item dashboard_box">
                <div class="dashboard-toolbar--field-group__label">
                  <v-icon small color="success">mdi-check-circle-outline</v-icon>
                  Aprobadas:
                </div>
                <div class="dashboard-toolbar--field-group__value text-green">
                  <div class="dashboard-toolbar--field-group__value__text">
                    <span class="number">{{ stats.approvedCount }}</span>
                    <span class="unit"> solicitudes</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-divider class="mb-4" v-if="stats"></v-divider>
          <!-- sectionHeader end -->
          <div class="dashboard-toolbar--selector pb-3 d-flex">
            <div class="dashboard-toolbar--field-group mr-5">
              <div class="dashboard-toolbar--field-group__label work-center">
                <v-icon small>mdi-office-building-marker</v-icon>
                Centro de trabajo:
              </div>
              <div class="dashboard-toolbar--field-group__value">
                <div class="dashboard-toolbar--field-group__value__text"
                  v-if="workcenterId !== null">
                  <!-- vuetify input selector -->
                  <v-select style="min-width: 400px;" v-model="selectedWorkcenterId" :items="workcenters"
                    :placeholder="workcenterName ? workcenterName : 'Seleccionar Centro de Trabajo'"
                    outlined dense hide-details @change="updateSelectedWorkcenter()">
                  </v-select>
                </div>
              </div>
            </div>
            <div class="dashboard-toolbar--field-group">
              <div class="dashboard-toolbar--field-group__label work-center">
                <v-icon small>mdi-calendar</v-icon>
                Año:
              </div>
              <div class="dashboard-toolbar--field-group__value">
                <div class="dashboard-toolbar--field-group__value__text">
                  <!-- vuetify input selector -->
                  <v-select v-model="selectedYear" :items="years"
                    :placeholder="selectedYear ? selectedYear.toString() : 'Seleccionar Año'"
                    outlined dense hide-details></v-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-0 px-4">
          <N3WorkerTable v-if="selectedWorkcenterId" :workCenterId="selectedWorkcenterId"
            :selectedYear="selectedYear" :showDetails="true" @entries-loaded="updateStats" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import n3Service from '@/services/n3.service';
import SectionHeader from '@/components/Headers/SectionHeader.vue';
import workcenterService from '@/services/workcenter.service';
import N3WorkerTable from '@/views/_FATDA/components/N3WorkerTable.vue';

export default {
  name: 'export-clock-entries',
  data() {
    return {
      loading: false,

      workcenterId: null,
      workcenterName: null,

      years: [2025, 2026],
      currentYear: new Date().getFullYear(),
      selectedYear: null,
      workers: null,
      n3Entries: null,

      workcenters: null,
      selectedWorkcenterId: null,
      selectedWorkcenterName: null,
      stats: null,

      isSuperAdmin: false,
    };
  },
  components: {
    SectionHeader,
    N3WorkerTable,
  },
  created() {
    this.getWorkcenters();
    this.isSuperAdmin = this.$store.getters['auth/hasRole'](['ROLE_SUPER_ADMIN']);
  },
  mounted() {
    if (this.$store.state.projectId === null) {
      this.$router.push({ name: 'SelectWorkCenter' });
    } else {
      this.workcenterId = this.$store.state.projectId;
      console.log('Selected workcenter ID mounted():', this.workcenterId);
      this.workcenterName = this.$store.state.project;
    }
    this.selectedWorkcenterId = this.workcenterId;
    this.selectedWorkcenterName = this.workcenterName;
    this.selectedYear = this.currentYear;
  },
  methods: {
    getWorkcenters() {
      workcenterService.getAllWorkcenters().then((response) => {
        this.sourceOptions = response.content.map((ele) => ({
          value: ele.id,
          text: ele.name,
          description: ele.description,
          typeId: ele.workcenterType,
          creationTime: new Date(ele.creationTime).toLocaleDateString(),
          icon: 'business_center',
          color: '#424242',
          availableClockEntries: ele.availableClockEntries,
          availableSchedule: ele.availableSchedule,
        }));
        this.workcenters = this.sourceOptions;
      });
    },
    updateSelectedWorkcenter() {
      // find in workcenters array the selected workcenter
      const val = this.workcenters.find((ele) => ele.value === this.selectedWorkcenterId);
      this.selectedWorkcenterName = val.text;
      console.log('Updated selected workcenter to:', this.selectedWorkcenterId, this.selectedWorkcenterName);
    },
    exportN3excel() {
      this.loading = true;
      if (this.n3Entries) {
        this.exportN3Entries();
      } else {
        this.loading = false;
      }
    },
    exportN3Entries() {
      const eventsCl = [];
      console.log('N3 Entries fetched:', this.n3Entries);
      // items foreach
      this.n3Entries.forEach((item) => {
        eventsCl.push({
          id: item.id,
          year: item.year,
          month: item.month,
          amount: parseFloat(item.amount).toFixed(2),
          approved: item.approved,
          information: item.information,
          workerId: item.worker.id,
          idDocument: item.worker.idDocument,
          workerName: item.worker.name,
          workerLastName: item.worker.lastName1,
          workerEmail: item.worker.email,
          worker: item.worker,
          workcenterName: this.workcenterName,
        });
      });
      this.eventsN3 = eventsCl;
      n3Service.downloadN3EntriesForAllWorkers(eventsCl, this.selectedYear, this.selectedWorkcenterName, this.selectedWorkcenterId);
      this.loading = false;
    },
    updateStats(entries) {
      this.n3Entries = entries;
      const totalAmount = entries.reduce((sum, entry) => sum + parseFloat(entry.amount || 0), 0);
      const pendingCount = entries.filter((e) => !e.approved).length;
      const approvedCount = entries.filter((e) => e.approved).length;

      this.stats = {
        totalAmount: totalAmount.toFixed(2),
        pendingCount,
        approvedCount,
      };
    },
  },
  computed: {
    availableN3() {
      return this.$store.state.availableN3 === 'true';
    },
  },
};
</script>
<style scoped>
.dashboard-toolbar--insights {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.insight-item {
  padding: 15px 20px;
  border-radius: 8px;
  min-width: 200px;
}

.dashboard-toolbar--field-group__value__text {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
